import _ from 'lodash';
import Vue from 'vue';
import numberFormat from 'number-format.js';

export default ({ app: { jk }, store }) => {
  const CN = store.state.constant;
  const filters = _.extend({
    str(value, isTrim, sep) {
      if (jk.isEmpty(value)) {
        return '';
      } if (jk.isArray(value)) {
        if (!isTrim) {
          return value.join(sep || ', ');
        }
        return value.map(v => _.trim(v)).join(sep || ', ');
      } if (isTrim) {
        return _.trim(`${value}`);
      }
      return `${value}`;
    },
    tplStr(tplStr, data, needValue) {
      let isAllEmpty = true;
      let value = tplStr.replace(/(\$\{([^{}]+)\})/g, item => {
        let match = item.match(/\$\{([^{}]+)\}/);
        if (isAllEmpty && !jk.isEmpty(data[match[1]])) isAllEmpty = false;
        return data[match[1]];
      });
      if (needValue && isAllEmpty) return '';
      return value;
    },
    omit(value, str, extraJudge) {
      if (extraJudge || typeof (extraJudge) === 'undefined') {
        if (typeof (value) === 'undefined' || value === null) return str || '-';
        if ((`${value}`) == '') return str || '-';
        return value;
      }
      return value;
    },
    unit(value, unit, index) {
      if (jk.isEmpty(value)) return '';
      if (!unit) {
        return value;
      } if (!jk.isEmpty(index)) {
        unit = filters.options(index, unit);
      }
      return jk.trim(`${value} ${unit}`);
    },
    truncate(str, max, padStr, showMore) {
      if (jk.isEmpty(str)) return '';
      let str1 = jk.str.truncate(str, max, padStr);
      if (showMore && str != str1) {
        str1 = `<span title="${jk.escape(str)}">${jk.escape(str1)}</span>`;
      } else {
        //str1=jk.escape(str1);
      }
      return str1;
    },

    /**
     * @author: francklin
     * @modified: 2018.5.17
     */
    options(value, vOptions, sensitive) {
      if (jk.isEmpty(value)) return '';
      let options = [];
      let val = (sensitive || jk.isBoolean(value)) ? value : String(value);
      if (!vOptions) {
        return value;
      } if (typeof (vOptions) === 'string') {
        options = vOptions.replace(/\:/g, '|').split(';');
      } else if (jk.isArray(vOptions)) {
        options = vOptions;
      }
      for (let i = 0; i < options.length; i++) {
        if (jk.isString(options[i])) {
          let values = options[i].split('|');
          if (sensitive && val === values[1]) {
            return values[0];
          } if (val == values[1]) {
            return values[0];
          }
        } else if (jk.isArray(options[i])) {
          if (sensitive && val === options[i][1]) {
            return options[i][0];
          } if (val == options[i][1]) {
            return options[i][0];
          }
        } else if (jk.isObject(options[i])) {
          if (options[i].hasOwnProperty('sendValue')) {
            if (sensitive && val === options[i].sendValue) {
              return options[i].showValue;
            } if (val == options[i].sendValue) {
              return options[i].showValue;
            }
          } else {
            if (sensitive && val === options[i].value) {
              return options[i].text || options[i].label;
            } if (val == options[i].value) {
              return options[i].text || options[i].label;
            }
          }
        }
      }
      return value;
    },

    /**
     * @author: francklin
     * @created: 2020.05.16
     */
    optionsExt(values, vOptions, sensitive, sep) {
      values = values || [];
      let arr = [];
      for (let i = 0; i < values.length; i++) {
        arr.push(filters.options(values[i], vOptions, sensitive, sep));
      }
      return arr.join(sep || ', ');
    },
    // 数字格式化
    numberFormat(value, format) {
      if (jk.isNumber(value)) {
        return numberFormat(format, value);
      } if (/^\d+$/.test(value)) {
        return numberFormat(format, Number(value));
      }
      return value || '';
    },

    /**
     * 数字拆分为整数和小数，并利用标签连接
     * @para tagName: html标签名，一般为“i”，缺省为输出不带小数的二元数组
     * @authoer: francklin
     * @created: 2020.12.09
     */
    numberSplit(value, tagName) {
      let str = '';
      if (jk.isNumber(value) || /^\d+$/.test(value)) {
        if (tagName) {
          return `<${tagName}>${value.toString().split('.').join(`</${tagName}><${tagName}>.`)}`;
        }
        return value.toString().split('.');
      }
      return value || '';
    },
    currency(code) {
      switch (code) {
        case 'CNY':
          return '人民币';
          break;
        case 'USD':
          return '美元';
          break;
      }
    },
    defaultImage(shortName, shortName1) {
      if (!shortName && shortName1) shortName = shortName1;
      if (!shortName) {
        return CN.DEFAULT.IMAGE;
      } if (typeof (shortName) !== 'string') {
        return shortName;
      } if (shortName.indexOf('/') < 0) {
        return CN.DEFAULT[`IMAGE_${shortName.toUpperCase()}`];
      }
      return shortName;
    },
    getImage(imgUrl, defaultImage) {
      if (!imgUrl) {
        if (typeof (defaultImage) !== 'undefined') {
          imgUrl = filters.defaultImage(defaultImage);
        }
      } else if (imgUrl.indexOf('//') == 0 || imgUrl.slice(0, 8).indexOf('://') > 0) {
        //none
      } else {
        imgUrl = CN.IMG_ADDRESS + imgUrl;
      }
      return imgUrl;
    }
  }, {
    imgCdn(val) {
      if (val) {
        return CN.IMG_ADDRESS + val;
      }
      return val;
    },
    htmlTag(val) {
      if (typeof val === 'string') {
        return val.replace(/<[^>]+>/g, '');
      }
      return val;
    }
  });

  // 注册filters到Vue
  for (let key in filters) {
    Vue.filter(key, filters[key]);
  }
};
